import { Component, OnInit } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { ApiService, UploadFileList } from '../../services/api.service';
import { CommonModule } from '@angular/common';
import { ButtonDirective } from 'primeng/button';

@Component({
  selector: 'app-upload-list',
  standalone: true,
  imports: [
    CommonModule,
    PrimeTemplate,
    TableModule,
    FormsModule,
    ButtonDirective,
  ],
  templateUrl: './upload-list.component.html',
  styleUrl: './upload-list.component.scss',
})
export class UploadListComponent implements OnInit {
  files: UploadFileList[] = [];

  data: any[] = [];

  groups: string[] = [];

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.apiService.getUploadedFiles().subscribe(files => {
      this.files = Array.isArray(files)
        ? files.map(f => ({
            ...f,
            lastMatrix: new Date(f.date),
          }))
        : Object.values(files).map((value: any) => ({
            team: value.team,
            members: value.members,
            date: new Date(value.date),
          }));
    });
  }

  confirmAndDelete(team: string, date: Date) {
    if (
      window.confirm(
        'Are you sure you want to permanently delete data for ' +
          team +
          ' collected on ' +
          date +
          '?\n\nThis action cannot be undone, but you can re-upload the original file later.'
      )
    ) {
      this.deleteFromDb(team, date);
    }
  }

  deleteFromDb(team: string, date: Date) {
    this.apiService.deleteUpload(team, date).subscribe({
      next: () => {
        // Ricarica la lista dopo la cancellazione
        this.ngOnInit(); // oppure this.loadFiles() se hai un metodo dedicato
      },
      error: err => {
        // Gestisci eventuali errori
        console.error('Errore durante la cancellazione:', err);
      },
    });
  }
}
